<template>
  <el-card class="ik-chart-card">
    <div slot="header" class="clearfix">
      <span class="ik-chart-card-title">{{ title }}</span>
      <p class="table_title_img" />
      <span class="logo" />
    </div>
    <div :id="code" :style="'width: 100%;height: ' + height + ';'" />
  </el-card>
</template>

<script>
import {
  dimensionExtraction,
  initSingleSeries
} from "@/components/ik/echarts/dataProcess"
import theme from "@/components/ik/echarts/theme/ik.json"
import * as echarts from "echarts"

export default {
  name: "IkPieBaseChart",
  props: {
    title: {
      type: String,
      default: "标题"
    },
    code: {
      type: String,
      default: "bar.base"
    },
    data: {
      type: Array,
      default: function() {
        return [
          { type: "类型1", dep: "部门1", value: "30" },
          { type: "类型1", dep: "部门2", value: "30" },
          { type: "类型1", dep: "部门1", value: "30" },
          { type: "类型4", dep: "部门2", value: "30" },
          { type: "类型4", dep: "部门1", value: "35" },
          { type: "类型4", dep: "部门2", value: "37" },
          { type: "类型6", dep: "部门1", value: "30" },
          { type: "类型6", dep: "部门2", value: "35" },
          { type: "类型6", dep: "部门1", value: "39" },
          { type: "类型7", dep: "部门1", value: "39" }
        ]
      }
    },
    // 数据分析维度 - 第一数据维度
    dataDimensionField: {
      type: String,
      default: "value"
    },
    dataDimensionMin: {
      type: String,
      default: ""
    },
    dataDimensionMax: {
      type: String,
      default: ""
    },
    dataDimensionInterval: {
      type: String,
      default: ""
    },
    dataDimensionUom: {
      type: String,
      default: ""
    },
    gridType: {
      type: String,
      default: "summary"
    },
    // 数据分析维度 - 第一分析维度 - 横坐标
    analysisDimensionField: {
      type: String,
      default: "type"
    },
    analysisDimension: {
      type: Array,
      default: function() {
        return []
      }
    },
    // 样式
    height: {
      type: String,
      default: "100%"
    }
  },
  data() {
    return {
      chartAnalysisDimension: [],
      chartSeries: []
    }
  },
  watch: {
    data() {
      this.init()
    }
  },
  mounted() {
    // setTimeout(() => {
    this.init()
    // }, 5000)
  },
  methods: {
    init() {
      const $this = this
      // 初始化 chart 样式
      // 基于准备好的dom，初始化echarts实例
      const dom = document.getElementById($this.code)
      echarts.registerTheme("ik", theme)
      // 初始化组件，配合主题 - 'dark'
      const myChart = echarts.init(dom, "ik")
      // 如果第一维度不存在，通过字段抽取
      if ($this.analysisDimension.length === 0) {
        // 第一维度必需
        if ($this.analysisDimensionField === '') {
          console.log('1')
        }
        $this.chartAnalysisDimension = dimensionExtraction(
          $this.data,
          $this.analysisDimensionField
        )
      } else {
        $this.chartAnalysisDimension = $this.analysisDimension
      }

      // 生成 series
      const series = initSingleSeries(
        $this.data,
        $this.chartAnalysisDimension,
        [],
        $this.analysisDimensionField,
        "",
        $this.dataDimensionField,
        $this.gridType
      )

      // 生成数据轴数据
      const axis = {}
      if ($this.dataDimensionMin !== "") {
        axis["min"] = Number($this.dataDimensionMin)
      }
      if ($this.dataDimensionMax !== "") {
        axis["max"] = Number($this.dataDimensionMax)
      }
      if ($this.dataDimensionInterval !== "") {
        axis["interval"] = Number($this.dataDimensionInterval)
      }
      if ($this.dataDimensionUom !== "") {
        console.log('1')
      }

      //
      const chartSeriesData = []
      for (const key in series["数据"]) {
        chartSeriesData.push({
          name: $this.chartAnalysisDimension[key],
          value: series["数据"][key]
        })
      }
      const chartSeries = {
        name: "数据",
        type: "pie",
        data: chartSeriesData
      }

      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "right",
          data: $this.chartAnalysisDimension
        },
        series: chartSeries
      })
    }
    // 切换密码显示
  }
}
</script>
